
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMotionRelativeIec as ObiMotionRelativeIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-motion-relative-iec.js';
 
 
 

 
 export const ObiMotionRelativeIec = createComponent({
   react: React,
   tagName: 'obi-motion-relative-iec',
   elementClass: ObiMotionRelativeIecElement,
   events: {
     
   }
  });
 
 